/**
 * Labstep
 *
 * @module components/Layout/SubPage
 * @desc Sub page on RightPane
 */

import classnames from 'classnames';
import { RightPaneSubPageHeader } from 'labstep-web/components/Layout/RightPane/SubPage/Header';
import { MediaQueryDesktop as Desktop } from 'labstep-web/core/MediaQuery/Desktop';
import type React from 'react';
import styles from './styles.module.scss';
import type {
  RightPaneSubPageContainerProps,
  RightPaneSubPageProps,
} from './types';

export const RightPaneSubPage: React.FC<RightPaneSubPageProps> = ({
  header,
  children,
  desktop,
  ...rest
}) => (
  <div
    className={classnames({
      [styles.desktopRight]: desktop,
      [styles.mobile]: !desktop,
    })}
  >
    <div className={styles.container}>
      {header && (
        <div className={styles.header}>
          <RightPaneSubPageHeader header={header} {...rest} />
        </div>
      )}
      <div id="right-pane-body" className={styles.body}>
        {children}
      </div>
    </div>
  </div>
);

export const RightPaneSubPageContainer: React.FC<
  RightPaneSubPageContainerProps
> = (props) => (
  <Desktop>
    {({ match }): React.ReactElement => (
      <RightPaneSubPage desktop={match} {...props} />
    )}
  </Desktop>
);
